import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AppState {
  isHydrated: boolean;
  theme: "light" | "dark";
  setHydrated: (value: boolean) => void;
  setTheme: (theme: "light" | "dark") => void;
}

export const useAppStore = create<AppState>()(
  devtools((set) => ({
    isHydrated: false,
    theme: "light",
    setHydrated: (value) => set({ isHydrated: value }),
    setTheme: (theme) => set({ theme }),
  })),
);
